import CookiePolicy from '@/components/elements/CookiePolicy';
import SurveyPopup from '@/components/elements/SurveyPopup';
import theme from '@/constants/theme';
import '@/styles/global.css';
import { ChakraProvider } from '@chakra-ui/react';
import { appWithTranslation } from 'next-i18next';
import { AppProps } from 'next/app';
import React from 'react';
import FacebookPixel from '@/components/elements/FacebookPixel';

function WebApp({ Component, pageProps }: AppProps) {
  return (
    <ChakraProvider theme={theme} resetCSS>
      <FacebookPixel />
      <Component {...pageProps} />
      <SurveyPopup />
      <CookiePolicy />
    </ChakraProvider>
  );
}
export default appWithTranslation(WebApp);
